<div class="container">
  <mat-tab-group (selectedTabChange)="updateParams($event)">
    <mat-tab *ngFor="let warehouse of warehouses; let i = index" [label]="'Bodega: ' + warehouse.name">

      <div class="mt-4">
        <data-table
          title="Inventario"
          [columns]="columnasI"
          [url]='urlTableI'
          [configuration]="configurationI"
          [reloadTable]="reloadTablaI[i]"
          [params]="params"
          [headerFileXlsm]="headerFileXlsm"
          [headerFilters]="headerFilters"
          (edit)="editStock($event, i)">
        </data-table>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
